import "../AppDesktop.css";
import { Button, Grid, Typography } from "@mui/material";
import ButtonCeci from "./ButtonCeci";

export default function Card1() {
    return (
        <Grid container size={12} sx={{width: '100%'}}>
            <Grid item size={1.5}/>
            <Grid item size={3.5} sx={{textAlign: 'left'}}>                
                <div style={{marginTop: '20vh'}} className="stile-titolo">MUOVITI MEGLIO <br/>VIVI MEGLIO!</div>
                <div style={{marginTop: '20px'}}className="stile-sottotitolo">Percorsi personalizzati per ritrovare <br/>equilibrio, benessere e salute</div>
                <ButtonCeci 
                    onClick={() => {
                        const el = document.getElementById("contatti");
                        if (el) {
                            el.scrollIntoView({ behavior: "smooth" });
                        }
                    }}
                    sx={{marginTop: "30px"}}>Fai una prova</ButtonCeci>
            </Grid>
        </Grid>
    );
}
